import ApiService from "@/core/services/api.service";
import i18nService from "@/core/services/i18n.service.js";
import SiteService from "@/core/services/site.service.js";

const state = {
  errors: null,
  collection: [],
};

const getters = {
  pageTagCollection(state) {
    return state.collection;
  },

  getPageTagByID: (state) => (id) => {
    let item = state.collection.find((item) => item.id == id);
    if (!item) {
      item = { name: "" };
    }
    return item;
  },
};

const actions = {
  fetchPageTags(context) {
    return new Promise((resolve) => {
      let appLocale = i18nService.getActiveLanguage();
      ApiService.get(
        "pages/admin/" + SiteService.getActiveSiteId() + "/tag"
      ).then(({ data }) => {
        // create localized fields
        let dataLocalized = data.map((item) => {
          if (item.translations) {
            let translations = item.translations[appLocale];
            if (translations) {
              Object.keys(translations).forEach((property) => {
                item[property] = item.translations[appLocale][property];
              });
            } else if (item.translations[0]) {
              for (const [key, value] of Object.entries(
                item.translations[Object.keys(item.translations)[0]]
              )) {
                if ("attachments" != key && "custom_fields" != key) {
                  item[key] = value;
                }
              }
            }
          }

          return item;
        });

        context.commit("fetchPageTags", dataLocalized);
        resolve();
      });
    }).catch((error) => {
      console.log("Error!: ", error);
    });
  },
};

const mutations = {
  fetchPageTags(state, data) {
    state.collection = data;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
